import {FirestoreTimestamp, QuizSession, QuizSessionDb, resetQuizSession} from '@cp/model';
import {addDoc, DocumentReference, serverTimestamp} from 'firebase/firestore';
import getQuizSessionCollection from './getQuizSessionCollection';

/**
 * Create a new quiz session from an existing session with answers cleared.
 * The trigger skips population when questions array is non-empty.
 */
export default async function createRetryQuizSessionDoc(
  uid: string,
  existingSession: QuizSession,
): Promise<DocumentReference<QuizSessionDb>> {
  const resetSession = resetQuizSession(existingSession, serverTimestamp() as unknown as FirestoreTimestamp);

  const col = getQuizSessionCollection(uid);
  return addDoc(col, resetSession as QuizSessionDb);
}
